// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ScheduleWorkspace = registerClientReference(
    function() { throw new Error("Attempted to call ScheduleWorkspace() from the server but ScheduleWorkspace is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(seller)/seller/schedule/seller-schedule-client.tsx",
    "ScheduleWorkspace",
);
export const SellerScheduleClient = registerClientReference(
    function() { throw new Error("Attempted to call SellerScheduleClient() from the server but SellerScheduleClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(seller)/seller/schedule/seller-schedule-client.tsx",
    "SellerScheduleClient",
);
